import { render } from "./News.vue?vue&type=template&id=c6681bf2&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=c6681bf2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c6681bf2"

export default script